<template>
  <entity-select-dialog
      ref="entitySelectDialog"
      :search="search"
      :items="items"
      :loading="loading">

    <template v-slot:listItem="props">
      <user-list-item :item="props.item"
                      :row-click-enabled="true"
                      :showActions="false"/>

    </template>
  </entity-select-dialog>
</template>

<script>
import EntitySelectDialog from '@/components/entity-crud/EntitySelectDialog';
import UserListItem from '@/views/users/UserListItem';
import UserService from '@/services/UserService';


export default {
  name: 'UserSelectDialog',
  components: { UserListItem, EntitySelectDialog },

  data: () => ({
    items: [],
    loading: false,
  }),

  methods: {

    selectedEntity(user) {
      this.$emit('selected', user);
      this.close();
    },

    show() {
      this.$refs.entitySelectDialog.show();

    },

    close() {
      this.$refs.entitySelectDialog.close();
    },

    mapToItem(user) {
      return {
        user: user,
        rowClick: () => {
          this.selectedEntity(user);
        },
      };
    },
    search(searchTerm) {
      if (!searchTerm) {
        searchTerm = null;
      }

      this.items = [];
      this.loading = true;

      UserService.findByName(searchTerm).then(result => {
        this.items = result.data.map(this.mapToItem);
      }).catch(err => {
        console.log(err);
      }).finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>

</style>
